import { render, staticRenderFns } from "./JdsLocation.vue?vue&type=template&id=be3e3208&scoped=true&"
import script from "./JdsLocation.vue?vue&type=script&lang=ts&"
export * from "./JdsLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3e3208",
  null
  
)

export default component.exports